export default "__VITE_ASSET__C5fm5m1C__"